/* @ngInject */
function brandColorPaletteService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getBrandColorPalettes,
    createPalette,
    createPaletteColor,
    updatePalette,
    updatePaletteColor,
    deletePalette,
    deletePaletteColor
  }
  return service

  function getBrandColorPalettes () {
    return ConnectorWebService.get(CONSTANTS.URL_PALETTES)
  }

  function createPalette (palette) {
    return ConnectorWebService.post(CONSTANTS.URL_PALETTES, palette)
  }

  function createPaletteColor (paletteId, color) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PALETTES_ID_COLOR, [paletteId])
    return ConnectorWebService.post(url, color)
  }

  function updatePalette (paletteId, palette) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PALETTES_ID, [paletteId])
    return ConnectorWebService.put(url, palette)
  }

  function updatePaletteColor (paletteId, colorId, color) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PALETTES_ID_COLOR_ID, [paletteId, colorId])
    return ConnectorWebService.put(url, color)
  }

  function deletePalette (paletteId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PALETTES_ID, [paletteId])
    return ConnectorWebService.fnDelete(url)
  }

  function deletePaletteColor (paletteId, colorId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PALETTES_ID_COLOR_ID, [paletteId, colorId])
    return ConnectorWebService.fnDelete(url)
  }
}

export { brandColorPaletteService }
